import React from "react";
import { useRole } from "./useRole";

/**
 * Componente que muestra contenido solo si el usuario tiene el rol requerido
 * @param {string|string[]} requiredRoles - Rol(s) requerido(s)
 * @param {React.ReactNode} children - Contenido a mostrar
 * @param {React.ReactNode} fallback - Contenido alternativo si no tiene acceso
 */
export function ShowIfRole({ requiredRoles, children, fallback = null }) {
  const { hasAnyRole } = useRole();

  const rolesArray = Array.isArray(requiredRoles)
    ? requiredRoles
    : [requiredRoles];

  if (hasAnyRole(rolesArray)) {
    return children;
  }

  return fallback;
}

/**
 * Componente que muestra contenido solo si el usuario tiene acceso a una sección
 * @param {string} section - Sección a verificar
 * @param {React.ReactNode} children - Contenido a mostrar
 * @param {React.ReactNode} fallback - Contenido alternativo si no tiene acceso
 */
export function ShowIfHasSection({
  section,
  children,
  fallback = null,
}) {
  const { hasAccessToSection } = useRole();

  if (hasAccessToSection(section)) {
    return children;
  }

  return fallback;
}

/**
 * Componente que renderiza diferentes contenidos según el rol
 * @param {Object} config - Objeto con estructura { [rol]: contenido }
 * @param {React.ReactNode} defaultContent - Contenido por defecto
 */
export function RoleBasedContent({ config = {}, defaultContent = null }) {
  const { getUserRole } = useRole();

  const userRole = getUserRole();
  const content = config[userRole];

  return content ?? defaultContent;
}
